export const fontSizes = {
  title1: " 26px",
  title2: "22px",
  title3: "20px",
  text1: "18px",
  text2: "16px",
  text3: "14px",
  text4: "12px",
};
